var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import render from 'utils/render';
const SvgIcra = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const Element = render.element(/*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.89 12",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bf487671-9ce3-4373-8b21-c9072e857aa4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eb11d47c-44c0-4dd9-ade1-80ed5a012c8d",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a777d189-edd1-4ab1-86df-858eee5d4448",
    "data-name": "ICRA",
    d: "M0,11.9H2.65V.26H0ZM22.38.26H15V11.9h2.65V7.44h3.24a1.71,1.71,0,0,1,1.67,1.22V11.9h2.66V8.25c0-.71-1.09-1.62-1.48-1.82,1.28-.5,1.37-1.82,1.37-2.83,0-1.32-.39-3.34-2.75-3.34ZM21.11,2.39c1,0,1.27.6,1.27,1.42s-.3,1.51-1.27,1.51H17.77V2.39ZM3.73,6V8.87A3.34,3.34,0,0,0,6.48,11.8c.78.1,2.15.2,2.45.2,1.67,0,4.91,0,5.21-3.14V7.55H11.48c.3,1.82-1.37,2.12-2.45,2.12C6.09,9.67,6.38,8.15,6.38,6V6c0-2.12-.3-3.64,2.65-3.64,1.08,0,2.75.31,2.45,2.12h2.66V3.14C13.84,0,10.6,0,8.93,0c-.3,0-1.67.1-2.45.2A3.34,3.34,0,0,0,3.73,3.13ZM33.87.26h-4l-4,11.64h2.85l.88-2.43h4.61l.89,2.43h2.84ZM32,2.49l1.48,4.75H30.24l1.48-4.75Z"
  }))))));
  return /*#__PURE__*/React.createElement(Element.type, _extends({}, Element.props, {
    ref: ref
  }), children, Element.props.children);
});
export default /*#__PURE__*/React.memo(SvgIcra);